import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchServices, fetchServicesDetails } from "../Redux/slice/homeSlice";
import { Icon } from "@iconify/react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

const ServiceRap = styled.div`
  .upper-p {
    padding: 5px 15px;
    width: fit-content;
    height: 31px;
    display: flex;
    border: 1px solid #0000001a;
    color: #1c4b42;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }
  h1 {
    color: #1c4b42;
    font-size: 52px;
    line-height: 57px;
    font-weight: 400;
    max-width: 678px;
  }
  h2 {
    color: #1c4b42;
    font-size: 48px;
    line-height: 57px;
    font-weight: 400;
  }

  .detail-1-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .detail-1 img {
    width: 100%;
    height: auto;
    border-radius: 24px;
  }
  .detail-1 {
    display: flex;
    flex-direction: column;
    gap: 50px;

    background: linear-gradient(180deg, #f6f5f2 0%, #ffffff 100%);
    padding-top: 160px;
  }

  .detail-1-btn {
    width: 175px;
    height: 47px;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    color: #ffffff;
    background: #1c4b42;
    font-size: 15px;
    font-weight: 500;
  }
  .detail-1-circle {
    width: 47px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: #1c4b42;
  }
  .detail-1-upper-left:hover  .detail-1-btn {
    background: #b4e717;
    color: #1c4b42;
  }
  .detail-1-circle svg {
    color: #ffffff;
  }
   .detail-1-upper-left:hover  .detail-1-circle{
    background: #b4e717;
    color: #1c4b42;
  }
  .detail-1-upper-left:hover  .detail-1-circle svg{
    color: #1c4b42;
  }
  .detail-1-upper-left {
    display: flex;
    width: fit-content;
  }
  .detail-1-upper-all {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }
/* 
  .detail-2-left-upper h6 {
    width: 62px;
    height: 31px;
    font-size: 11px;
    font-weight: 500;
    display: flex;
    color: #1c4b42;
    border-radius: 100px;
    border: 1px solid #0000001a;
    justify-content: center;
    align-items: center;
  } */
  .detail-2-left-upper p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 430px;
    line-height: 22px;
  }
  .detail-2-left-upper h2 {
    max-width: 526px;
  }
  .detail-2-left-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .detail-2-btn {
    background: #1c4b42;
    color: #ffffff;
    font-size: 15px;
    text-decoration: none;
    width: 129px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }
  .detail-2-btn:hover {
    background: #b4e717;
    color: #1c4b42;
  }
  .detail-2-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between;
  }
  .detail-2-sub h4 {
    color: #1c4b42;
    font-size: 20px;
    font-weight: 500;
  }
  .detail-2-sub {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
 
  .detail-2-right {
    padding-bottom: 20px;
    border-bottom: 1px solid #0000001a;
  }
  .detail-2-circle {
    background: #f6f5f2;
    width: 30px;
    height: 30px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .detail-2-right p {
    color: #1c4b42;
    font-size: 16px;
    font-weight: 400;
    max-width: 630px;
    padding-top: 20px;
    margin-top: 20px;
      border-top: 1px solid #0000001a;
  }
  .detail-2-right-all {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .detail-2 {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 100px;
    align-items: flex-end;
  }
  .detail-3-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    border-radius: 100px;
    width: 24px;
    background: #1c4b42;
  }
  .detail-3-link {
    height: 56px;
    border: none;
    text-decoration: none;
    padding: 0px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #f6f5f2;
    color: #1c4b42;
    font-size: 18px;
    font-weight: 500;
    border-radius: 100px;
  }
  .detail-3-link:hover {
    background: #b4e717;
  }
  .detail-3 {
    margin-top: 100px;
    border-top: 1px solid #0000001a;
    padding-top: 40px;
    display: flex;
    gap: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
  }
 
  .detail-4-right {
    background: #b4e717;
  }
  .detail-4-left-img {
    width: 630px;
    height: 520px;
    border-radius: 24px;
  }
   .detail-4-right {
    border-radius: 24px;
    width: 629px;
    height: 520px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
  }
  .right-5-sub h2 {
    color: #1c4b42;
  
    
    max-width: 400px;
  }
  .right-5-sub {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .right-5-circle {
    background: #1c4b42;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    align-content: center;
  }
  .right-5-upper {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  .right-5-inner h4 {
    color: #1c4b42;
    font-size: 30px;
    font-weight: 500;
  }
  .right-5-inner p {
    color: #000000cc;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    max-width: 264px;
  }
  .right-5-inner {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .right-5-btn {
    background: #1c4b42;
    width: 157px;
    height: 47px;
    align-items: center;
    align-content: center;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    border-radius: 100px;
  }
  .right-5-down {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
  .detail-4 {
    display: flex;
    gap: 10px;
    margin-top: 100px;
    justify-content: space-between;
  }
  .detail-5-upper-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .detail-5-upper p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 509px;
    line-height: 22px;
  }
  .detail-5-upper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .detail-5-upper h2 {
    max-width: 719px;
    text-align: center;
  }
  .card-5-upper {
    background: #b4e717;
    width: 60px;
    height: 60px;
    color: #1c4b42;
    font-size: 15px;
    font-weight: 500;
    border-radius: 100px;
    display: flex;
    margin-left: 20px;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
  }
  .card-5-down h4 {
    color: #1c4b42;
    font-weight: 500;
    font-size: 22px;
  }
  .card-5-down p {
    max-width: 229px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 400;
    color: #000000cc;
  }
  .detail-4-right p {
    color: #000000cc;
    max-width: 377px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
  .card-5-down {
    background: #f6f5f2;
    display: flex;
    flex-direction: column;
    gap: 50px;
    padding: 30px 20px;
    padding-bottom: 50px;
    border-radius: 16px;
  }
  .detail-5-card {
    border: 1px solid #0000001a;
    padding: 20px;
    border-radius: 24px;
    height: 432px;
    width: 300px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
   .detail-5-card:hover {
    background: #b4e717;
   }

   .detail-5-card:hover  .card-5-upper{
    color: #b4e717;
    background: #1c4b42;
   }
  .detail-5-down {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .detail-5 {
    display: flex;
    flex-direction: column;
    gap: 50px;
    margin-top: 100px;
  }
  .detail-6-left h6 {
    border: 1px solid #0000001a;
    width: 90px;
    height: 31px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1c4b42;
  }
  .detail-6-left h2 {
    max-width: 546px;
  }
  .detail-6-btn {
    background: #1c4b42;
    border-radius: 100px;
    width: 200px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    font-size: 15px;
    color: #ffffff;
  }
    .detail-6-btn:hover {
      background: #b4e717;
      color: #1c4b42;
    }
  .detail-6-left-sub,
  .detail-6-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .detail-6-left {
    justify-content: space-between;
  }
  .card-6-upper img {
    width: 45px;
    height: 45px;
  }
  .card-6-upper p {
    color: #000000cc;
    font-size: 20px;
    line-height: 30px;
    max-width: 518px;
    font-weight: 400;
    margin-left: 45px;
  }
  .card-6-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card-6-down-left img {
    width: 54px;
    height: 54px;
    border-radius: 100px;
  }
  .card-6-down-left h4 {
    color: #1c4b42;
    font-size: 15px;
    font-weight: 500;
  }
  .card-6-down-left p {
    color: #7e7e7e;
    font-size: 11px;
    font-weight: 500;
  }
  .card-6-down-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .card-6-down-inner {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .card-6-circle {
    border-radius: 100px;
    width: 52px;
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
  }
  .card-6-down-right {
    display: flex;
    gap: 15px;
  }
  .card-6-down {
    display: flex;
    justify-content: space-between;
  }
  .detail-6-card {
    background: #f6f5f2;
    width: 640px;
    overflow: hidden;
    min-height: 400px;
    border-radius: 24px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 20px;
  }

  .-card {
    transition: transform 0.5s ease, opacity 0.5s ease;
  }
  .detail-6 {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 100px;
  }
  .slide-right {
    animation: slideRight 0.5s forwards;
  }
  .slide-left {
    animation: slideLeft 0.5s forwards;
  }

  @keyframes slideRight {
    from {
      transform: translateX(500px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideLeft {
    from {
      transform: translateX(-500px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  .detail-7-card-upper h6 {
    border: 1px solid #0000001a;
    width: 90px;
    height: 31px;
    font-size: 11px;
    font-weight: 500;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1c4b42;
  }
  .small-green-cirlce {
    width: 42px;
    height: 42px;
  
  }
  .detail-7-card-upper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .detail-7-card-middle h5 {
    color: #1c4b42;
    font-size: 48px;
    font-weight: 400;
  }
  .detail-7-card-middle h4 {
    background: #84e717;
    padding: 5px 10px;
    border-radius: 8px;
    color: #1c4b42;
    font-size: 48px;
    font-weight: 400;
    width: fit-content;
  }
  .detail-7-card-down {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
  }
  .detail-7-btn {
    background: #1c4b42;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 159px;
    height: 47px;
    border-radius: 100px;
  }
  .detail-7-card-down {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  }
  .detail-7-card-middle {
    display: flex;
    gap: 20px;
    flex-direction: column;
  }
  .detail-7-card {
    width: 600px;
    height: 330px;
    backdrop-filter: blur(40px);
    padding: 20px;
    background: #ffffffcc;
    border-radius: 24px;
    display: flex;

    transition: all 0.5s ease-in-out;
    justify-content: space-between;
    flex-direction: column;
  }

  .detail-7 {
    background-size: cover;
    height: 100vh;
    margin-top: 100px;
    position: relative;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .detail-11 {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    cursor: pointer;
  }
    .detail-11:hover  .detail-1-btn {
    background: #b4e717;
    color: #1c4b42;
  }
  .detail-1-circle svg {
    color: #ffffff;
  }
   .detail-11:hover  .detail-1-circle{
    background: #b4e717;
    color: #1c4b42;
  }
  .detail-11:hover  .detail-1-circle svg{
    color: #1c4b42;
  }
   @media (max-width: 1300px) { 
 .detail-5-card {
    
    height: 472px;
 }
   }
   @media (max-width: 1200px) {
.detail-4-left-img, .detail-4-right {
    width: 500px;
}
 }
  @media (max-width: 1100px) { 
 .detail-5-down {
    flex-wrap: wrap;
 }
  .detail-5-card {
    
    height: 432px;
 }
  }
@media (max-width: 992px) {
    h1 {
        font-size: 45px;
    }
    h2 {
        font-size: 40px;
    }
    .detail-2 {
        flex-wrap: wrap;
        align-items: flex-start;
    }
    .detail-4, .detail-6 {
        flex-direction: column;
        gap: 30px;
    }
    .detail-6-card {
        width: 100%;
        
    }
}
 @media (max-width: 700px) {
.detail-7-card {
    width: 100%;
    height: auto;
}
.detail-7-card-down {
    flex-wrap: wrap;
}
h2 {
  font-size: 28px !important;
  line-height: 32px !important;
}
h1 {
  font-size: 32px !important;
  line-height: 40px !important;
}
h4 {
  font-size: 19px !important;

}
.detail-7-card-middle h5,
.detail-7-card-middle h4 {
font-size: 28px !important;
}
 }
   @media (max-width: 600px) {
    
    .detail-4-left-img,
    .detail-5-card , 
    .detail-4-right {
    width: 100%;
}

 .detail-4-left-img {
  height: auto;
 }
 .detail-4-right {
  height: 400px;
 }
 .detail-3-link {
        width: 100%;
        justify-content: space-between;
    }
   }
    @media (max-width: 500px) {
   
   
   }
    @media (max-width: 400px) {
   
    .card-6-down {
        flex-wrap: wrap;
        gap: 20px;
    }
   }
`;

const ServicesDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [activeIndexNew, setActiveIndexNew] = useState(0);
  const [currentIndexNew, setCurrentIndexNew] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [letterIndex, setLetterIndex] = useState(0);
  const [direction, setDirection] = useState("right");
  const { serviceDetails } = useSelector((state) => state.content);
  console.log(serviceDetails);
  const marqueeText = [];
  const ourValues = [];
  



  const details = serviceDetails?.data?.service
  const services = serviceDetails?.data?.services
  const slidingText = serviceDetails?.data?.slidingText
  const testimonials =serviceDetails?.data?.testimonial || []


  let slidingTextContent = [];

  try {
    slidingTextContent = JSON.parse(slidingText?.content);
  } catch (err) {
    console.error("Invalid JSON:", err);
  }
  console.log(slidingTextContent);

  let faqs = [];

  try {
    faqs = JSON.parse(details.faq); // parse JSON string
  } catch (e) {
    faqs = [];
  }
    let process = [];

  try {
    process = JSON.parse(details.process); // parse JSON string
  } catch (e) {
    process = [];
  }
console.log(process);

  const toggleFAQ = (index) => {
    setActiveIndexNew((prev) => (prev === index ? null : index));
  };
  const activeItem = testimonials?.lists?.[currentIndexNew];
  useEffect(() => {
    dispatch(fetchServicesDetails(id));
  }, [dispatch]);


   const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (!slidingTextContent.length) return;

    const currentTitle = slidingTextContent[currentIndex].titles;

    if (letterIndex < currentTitle.length) {
      // type one letter at a time
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + currentTitle[letterIndex]);
        setLetterIndex((prev) => prev + 1);
      }, 100); // speed (ms) between letters
      return () => clearTimeout(timeout);
    } else {
      // wait before moving to next word
      const timeout = setTimeout(() => {
        setDisplayText("");
        setLetterIndex(0);
        setCurrentIndex((prev) => (prev + 1) % slidingTextContent.length);
      }, 1500); // pause after full word
      return () => clearTimeout(timeout);
    }
  }, [letterIndex, currentIndex, slidingTextContent]);

  const nextSlide = () => {
    setDirection("right");
    setCurrentIndexNew((prev) =>
      prev === testimonials?.lists?.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setDirection("left");
    setCurrentIndexNew((prev) =>
      prev === 0 ? testimonials?.lists?.length - 1 : prev - 1
    );
  };
   const handledetails =(id) => {
    navigate(`/services/details/${id}`)
  }
  return (
    <ServiceRap>
      <div className="detail-1 containers">
        <div className="detail-1-upper-all">
          <div className="detail-1-upper">
            <h6 className="upper-p">{details?.small_title}</h6>

            <h1>
                {details?.main_title?.split(" ").map((word, index) => {
              const targetIndexes = [0, 2]; // 2nd word (index 1), 3rd word (index 2)
              return targetIndexes.includes(index) ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              );
            })}
              </h1>
          </div>
          <div className="detail-1-upper-left">
            <a
              href={details?.btn_link}
              className="detail-1-btn"
              target="_blank"
              rel="noopener noreferrer"
            >{details?.btn_title}</a>
            <div className="detail-1-circle">
                  <Icon
                                width="14px"
                                height="14px"
                                icon="mdi:arrow-top-right"
                                
                              />
            </div>
          </div>
        </div>
        <img src={`https://backoffice.holybrookstransportation.com/${details?.banner}`} alt="" />
      </div>

      <div className="detail-2 containers">
        <div className="detail-2-left">
          <div className="detail-2-left-upper">
            <h6 className="upper-p">{details?.desc_small_title}</h6>
            <h2>
                    {details?.desc_main_title?.split(" ").map((word, index) => {
              const targetIndexes = [0, 1]; // 2nd word (index 1), 3rd word (index 2)
              return targetIndexes.includes(index) ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              );
            })}
             </h2>
             <div dangerouslySetInnerHTML={{ __html: details?.desc_overview }} />
          </div>
          <a
            href={details?.desc_btn_link}
            className="detail-2-btn"
            target="_blank"
            rel="noopener noreferrer"
          >{details?.desc_btn_title}</a>
        </div>
        <div className="detail-2-right-all">
          {faqs?.map((item, index) => (
            <div key={index} className="detail-2-right">
              <div
                className="detail-2-sub"
                onClick={() => toggleFAQ(index)}
                style={{ cursor: "pointer" }}
              >
                <h4>{item.question}</h4>
                <div className={`detail-2-circle`}>
                  <Icon
                    width="14px"
                    height="14px"
                    icon={
                      activeIndexNew === index ? "mdi:plus" : "ic:sharp-minus"
                    }
                    style={{ color: "#000000" }}
                  />
                </div>
              </div>
              {activeIndexNew === index && <p >{item.answer}</p>}
            </div>
          ))}
        </div>
      </div>
      <div className="containers">
        <div className="detail-3 ">
          {services?.map((item) => (
            <button 
              onClick={() => handledetails(id) }
              className="detail-3-link"
              
            >
              {item?.main_title}
              <div className="detail-3-circle">
                <Icon
                  width="14px"
                  height="14px"
                  icon="mdi:arrow-top-right"
                  style={{ color: " #B4E717" }}
                />
              </div>
            </button>
          ))}
        </div>
      </div>
      <div className="detail-4 containers">
        <img 
        src={`https://backoffice.holybrookstransportation.com/${details?.highlight_banner}`}
        className="detail-4-left-img" alt="" />
        <div className="detail-4-right">
          <div className="right-5-upper">
            <div className="right-5-sub">
              <h6 className="upper-p">{details?.highlight_small_title}</h6>
              <h2>{details?.highlight_main_title}</h2>
            </div>
            <div className="right-5-circle">
                <i
                  style={{
                    
                    fontSize: "20px",
                    color: "#ffffff"
                  }}
                  class={details?.hightlight_icon}
                ></i>
            </div>
          </div>

          <p>{details?.highlight_overview}</p>
        </div>
      </div>
      <div className="detail-5 containers">
        <div className="detail-5-upper">
          <h6 className="upper-p">{details?.process_small_title}</h6>
          <h2>
             {details?.process_main_title?.split(" ").map((word, index, arr) => {
                const targetIndexes = [arr.length - 2, arr.length - 1]; // 3rd & 2nd to last
                return targetIndexes.includes(index) ? (
                  <span key={index} style={{ color: "#b4e717" }}>
                    {word}{" "}
                  </span>
                ) : (
                  word + " "
                );
              })}
            </h2>
        </div>
        <div className="detail-5-down">
          {process?.map((item, index) => (
            <div className="detail-5-card">
              <div className="card-5-upper">0{index+1}</div>
              <div className="card-5-down">
                <h4>{item?.title}</h4>
                <p>{item?.overview}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="detail-11 containers">
            <a
              href={details?.btn_link}
              className="detail-1-btn"
              target="_blank"
              rel="noopener noreferrer"
            >{details?.btn_title}</a>
            <div className="detail-1-circle">
                  <Icon
                                width="14px"
                                height="14px"
                                icon="mdi:arrow-top-right"
                             
                              />
          </div>

      </div>
      <div className="detail-6 containers">
        <div className="detail-6-left">
          <div className="detail-6-left-sub">
            <h6>{testimonials?.heading?.small_title}</h6>
            <h2>
               {testimonials?.heading?.main_title?.split(" ").map((word, index, arr) => {
                const targetIndexes = [arr.length - 2, arr.length - 1]; // 3rd & 2nd to last
                return targetIndexes.includes(index) ? (
                  <span key={index} style={{ color: "#b4e717" }}>
                    {word}{" "}
                  </span>
                ) : (
                  word + " "
                );
              })}
              </h2>
          </div>
          <Link to="/testimonials" className="detail-6-btn">Read All Testimonials</Link>
        </div>

        {/* Active Testimonial */}
        <div className={`detail-6-card `}>
          <div className={`card-6-upper slide-${direction}`}>
            <img src="/images/icon-1.png" alt="" />
            <p>{activeItem?.testimony}</p>
          </div>
          <div className="card-6-down">
            <div className="card-6-down-left">
              <img
                src={`https://backoffice.holybrookstransportation.com/${activeItem?.image}`}
                alt=""
              />
              <div className={`card-6-down-inner slide-${direction}`}>
                <h4>{activeItem?.full_name}</h4>
                <p>{activeItem?.title}</p>
              </div>
            </div>
            <div className="card-6-down-right">
              <div className="card-6-circle" onClick={prevSlide}>
                <Icon
                  width="14px"
                  height="14px"
                  icon="mdi:arrow-bottom-left"
                  style={{ color: "#000000" }}
                />
              </div>
              <div className="card-6-circle" onClick={nextSlide}>
                <Icon
                  width="14px"
                  height="14px"
                  icon="mdi:arrow-top-right"
                  style={{ color: "#000000" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(https://backoffice.holybrookstransportation.com/${slidingText?.banner})`,
        }}
        className="detail-7 containers"
      >
        <div className={`detail-7-card`}>
          <div className="detail-7-card-upper">
            <h6>{slidingText?.small_title}</h6>
             <img
              className="small-green-cirlce"
              alt=""
              src="/images/icon-3.png"
            />
          </div>
          <div className="detail-7-card-middle">
            <h5>{slidingText?.main_title}</h5>
            <h4>{displayText}</h4>
            <div className="detail-7-card-down">
              <p>{slidingText?.bottom_text}</p>
              <a
                href={slidingText?.first_btn_link}
                className="detail-7-btn"
                target="_blank"
                rel="noopener noreferrer"
              >{slidingText?.first_btn_title}</a>
            </div>
          </div>
        </div>
      </div>
    </ServiceRap>
  );
};

export default ServicesDetails;
